import { queryKeys } from '@/constants/query-key';
import { ApiNamePaths } from '@/constants/rest-api-name-path';
import type { DriveDetail } from '@/features/driver/types/driveDetail';
import { useGenericQuery } from '@/modules/hooks/use-query';

export const useDrives = (vehicleOperationScheduleId: string) =>
  useGenericQuery<DriveDetail>(
    queryKeys.v1ReservationsStatus,
    ApiNamePaths.drivesGetApi.apiName,
    `${ApiNamePaths.drivesGetApi.apiPath}/${vehicleOperationScheduleId}`,
  );
